import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, VaultEntryResponseData } from "schema"

export const vaultQuery = () =>
  queryOptions({
    queryKey: ["companyVault"],
    queryFn: async () => {
      const { data } = await axios.get<DataResponse<VaultEntryResponseData[]>>("/vault")
      return data.data
    },
  })
